// JOBE-0166.1: PromptOpsSuitesPage — /promptops/suites route (W7).
// Renders a list of SuiteCard components, one per eval suite.
// The ?id=<suiteId> query param expands and scrolls to the matching card.

import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PromptOpsSubNav } from '../components/PromptOpsSubNav/PromptOpsSubNav.jsx';
import { useEvalSuites } from './useEvalSuites.js';
import { SuiteCard } from './SuiteCard.jsx';
import './PromptOpsSuitesPage.css';

export function PromptOpsSuitesPage() {
  const { suites } = useEvalSuites();
  const [searchParams] = useSearchParams();
  const expandId = searchParams.get('id') ?? null;

  // Scroll the expanded card into view after render.
  useEffect(() => {
    if (!expandId) return;
    // Brief delay to let the expanded body render before scrolling.
    const id = expandId;
    requestAnimationFrame(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }, [expandId]);

  return (
    <div className="promptops-suites-page">
      <PromptOpsSubNav agentName={null} />
      <div className="suites-list">
        {suites.map((suite) => (
          <SuiteCard
            key={suite.id}
            suite={suite}
            defaultExpanded={suite.id === expandId}
          />
        ))}
      </div>
    </div>
  );
}
